"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BookingEssentials() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const body = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3678" id="booking-essentials" className="dark bg-background text-foreground relative overflow-hidden py-28 md:py-36 lg:py-44 px-6 md:px-10">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(circle at 70% 50%, hsla(25, 35%, 35%, 0.25) 0%, transparent 55%)"
    }} />

      <div className="relative mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-8 lg:col-start-2">
            <div ref={eyebrow.ref} className={`mb-10 transition-all duration-700 ease-out ${eyebrow.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <span className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">BOOKING</span>
              <div className="mt-4 h-px w-16 bg-border" />
            </div>

            <h2 ref={heading.ref} className={`font-default font-light text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight text-foreground transition-all duration-1000 ease-out ${heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              Your glow
              <br />
              <span className="italic font-light" style={{
              color: "hsl(25 35% 65%)"
            }}>
                awaits.
              </span>
            </h2>

            <p ref={body.ref} className={`mt-10 max-w-xl text-lg md:text-[18px] leading-relaxed text-muted-foreground transition-all duration-700 delay-150 ease-out ${body.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Step into the studio and let our artists craft a look
              made entirely for you — download our bridal contract or
              schedule a private consultation at your convenience.
            </p>

            <div ref={ctas.ref} className={`mt-12 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-4 transition-all duration-700 delay-300 ease-out ${ctas.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Link to="/BridalSuitePage">
                <Button size="lg" className="h-14 px-8 text-base font-medium group bg-primary text-primary-foreground hover:bg-primary/90">
                  Download Contract
                  <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Button>
              </Link>

              <Link to="/GetInTouchPage" className="inline-flex items-center text-base font-medium text-foreground underline underline-offset-8 decoration-1 hover:decoration-2 transition-all px-2">
                Reserve Your Date
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-3 lg:col-start-10 flex justify-center lg:justify-end">
            <div ref={image.ref} className={`relative transition-all duration-1000 ease-out ${image.isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              {}
              <div aria-hidden="true" className="absolute inset-0 -m-6 blur-2xl opacity-40" style={{
              background: "hsl(25 35% 35%)"
            }} />
              <div className="relative w-64 h-64 md:w-80 md:h-80 overflow-hidden shadow-2xl" style={{
              borderRadius: "0px"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_makeup_application.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_makeup_application.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_makeup_application.png-wvc-sizes" alt="A professional makeup artist applying delicate bridal highlights at Joanne Glow Studio" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}